<template>
  <nav class="flex flex-wrap w-full justify-center" aria-label="catalogs">
    <router-link
      v-for="brand in productBrands" :key="brand.id"
      :to="'/brand/'+brand.slug.toLowerCase()" aria-label="Catalog Salvi"
      class="cursor-pointer w-40 md:w-1/2 p-1"
    >
      <div class="flex justify-center w-full h-auto bg-b2c-grey-600 text-b2c-grey-100 px-4 py-2 items-center rounded-lg hover:text-b2c-grey-600 hover:bg-b2c-grey-100">
        <img :src="brand.url_logo" :alt="brand.name" class="h-32 py-4">
      </div>
    </router-link>
  </nav>
</template>

<script>
export default {
  props: ['productBrands'],
};
</script>
